import { identity, values } from 'lodash-es';
import { useMemo } from 'react';
import { MarketAccountStatusEnum } from '../../../../types';
import { IconName } from '../../../Icons';
import type { FilterableProperty } from '../types';

export const useMarketAccountStatusesFilter = ({ label = 'Market Account Status' }: { label?: string } = {}) => {
  return useMemo(
    () =>
      ({
        key: 'MarketAccountStatuses',
        field: 'Status',
        label: label,
        icon: IconName.CheckCircle,
        options: values(MarketAccountStatusEnum),
        getOptionLabel: identity,
      }) as const satisfies FilterableProperty,
    [label]
  );
};
